import React from 'react';
import styled from 'styled-components';
import type { EpiDocumentType } from '../types/types';
import EpiSidebar from './EpiSidebar';
import EpiContent from './EpiContent';

interface IProps {
  docType: EpiDocumentType;
}

const EpiContainer: React.FC<IProps> = ({ docType }) => {
  return (
    <StyledContainer>
      <Wrapper>
        <EpiSidebar docType={docType} />
        <EpiContent />
      </Wrapper>
    </StyledContainer>
  );
};

export default EpiContainer;

const StyledContainer = styled.div`
  height: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 0 20px;
`;
